import { Injectable } from '@angular/core';
import { Shipment } from 'app-modules/core/models/shipment.model';

@Injectable()
export abstract class ICloseShipmentPopup {
    abstract OpenCloseShipmentPopup(shipment: Shipment, islistViewAction: boolean): void;
}
